const cartPaymentMethodsInfo = `
  available_payment_methods {
    code
    title
  }
  selected_payment_method {
    code
    title
  }
`;

export default cartPaymentMethodsInfo;
